var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 442 434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M190.5 38.5c18.336-.167 36.67 0 55 .5 28.557 5.223 47.057 21.723 55.5 49.5 1.425 16.618 1.925 33.285 1.5 50 17.883 4.385 30.383 15.052 37.5 32 14.535 45.939 28.869 91.939 43 138 4.005 27.158-6.162 46.991-30.5 59.5-4.554 1.741-9.221 3.074-14 4-80.333.667-160.667.667-241 0-31.576-8.293-46.076-28.793-43.5-61.5 14.333-46.333 28.667-92.667 43-139 6.909-18.086 19.742-29.086 38.5-33-.167-16.003 0-32.003.5-48 7.649-28.485 25.816-45.818 54.5-52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f4",
    d: "M254.5 99.5v33h-4c-22.665-1.289-45.331-1.289-68 0-.167-11.671 0-23.338.5-35 2.167-4.833 5.667-8.333 10.5-10.5 16.667-.667 33.333-.667 50 0 6.345 1.882 10.011 6.049 11 12.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#727273",
    d: "M254.5 99.5c.995 11.154 1.328 22.488 1 34-1.915.284-3.581-.049-5-1h4v-33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightIcon);
export default __webpack_public_path__ + "static/media/weightIcon.f7b379653e81689bd2080bfd8b444f9c.svg";
export { ForwardRef as ReactComponent };